import { render, staticRenderFns } from "./ReadOrder.vue?vue&type=template&id=561b0098"
import script from "./ReadOrder.vue?vue&type=script&lang=js"
export * from "./ReadOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports